import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "passwordPolicy";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const PASSWORD_EXAMPLE = {
    DIFFERENT_LETTER_CASES: "PassWord",
    SPECIAL_CHARACTERS: "p@ss#0rd_!",
    NUMBERS: "1234PassWord"
};
